import { Gift, Trophy, Sparkles, ExternalLink } from "lucide-react";
import { WHATSAPP_PASSENGERS_GROUP } from "../../lib/troy";

export default function Prizes() {
  return (
    <section
      id="premios"
      data-testid="prizes-section"
      className="relative py-24 md:py-32 border-t border-white/5 overflow-hidden"
    >
      {/* Decorative glows */}
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_30%_50%,rgba(255,204,0,0.10),transparent_55%)]" />
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_80%_60%,rgba(255,59,48,0.10),transparent_55%)]" />

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative rounded-[32px] overflow-hidden border border-[#FFCC00]/30 bg-gradient-to-br from-[#1A1300] via-[#0F0F0F] to-[#1A0606] p-8 md:p-16 grain">
          <div className="grid lg:grid-cols-12 gap-10 items-center relative">
            <div className="lg:col-span-7">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-[#FFCC00] text-black text-[10px] font-black tracking-[0.25em] uppercase mb-6">
                <Sparkles className="w-3.5 h-3.5" />
                Sorteio mensal
              </div>
              <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter leading-[1.02] mb-5 text-balance">
                Cada corrida no grupo é{" "}
                <span className="text-[#FFCC00]">um número da sorte</span>.
              </h2>
              <p className="text-white/75 text-lg leading-relaxed max-w-xl">
                Pedindo sua corrida pelo{" "}
                <strong className="text-white">grupo oficial da Troy no WhatsApp</strong>,
                você concorre automaticamente aos{" "}
                <strong className="text-white">prêmios do mês</strong>. Quanto mais
                corridas, mais chances de ganhar.
              </p>

              <ul className="mt-7 grid sm:grid-cols-2 gap-3">
                {[
                  { icon: Gift, label: "Brindes Troy" },
                  { icon: Trophy, label: "Corrida grátis" },
                  { icon: Sparkles, label: "Surpresas mensais" },
                  { icon: Gift, label: "Sem letrinha miúda" },
                ].map((b) => (
                  <li
                    key={b.label}
                    className="flex items-center gap-3 px-4 py-3 rounded-2xl bg-white/5 border border-[#FFCC00]/15"
                    data-testid={`prize-perk-${b.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    <span className="w-9 h-9 rounded-xl bg-[#FFCC00]/15 border border-[#FFCC00]/30 text-[#FFCC00] flex items-center justify-center">
                      <b.icon className="w-4 h-4" />
                    </span>
                    <span className="text-white/90 font-semibold">{b.label}</span>
                  </li>
                ))}
              </ul>

              <a
                href={WHATSAPP_PASSENGERS_GROUP}
                target="_blank"
                rel="noreferrer noopener"
                data-testid="prizes-cta"
                className="mt-8 inline-flex items-center gap-2 bg-[#FFCC00] text-black font-bold py-4 px-8 rounded-full hover:bg-[#E6B800] transition-all transform hover:-translate-y-1 shadow-[0_0_32px_rgba(255,204,0,0.4)]"
              >
                <ExternalLink className="w-4 h-4" />
                Entrar no grupo e concorrer
              </a>
              <p className="mt-3 text-xs text-white/50">
                Participam todos que solicitarem corrida pelo grupo no mês vigente.
              </p>
            </div>

            <div className="lg:col-span-5 relative">
              <div className="relative aspect-square max-w-md mx-auto">
                {/* Trophy badge */}
                <div className="absolute inset-0 rounded-full bg-gradient-to-br from-[#FFCC00] via-[#FFB800] to-[#E69500] flex items-center justify-center shadow-[0_0_80px_rgba(255,204,0,0.45)]">
                  <Trophy className="w-32 h-32 md:w-44 md:h-44 text-black" strokeWidth={1.5} />
                </div>
                {/* Floating chips */}
                <div className="absolute -top-2 -left-4 px-4 py-2 rounded-full bg-black border border-[#FFCC00]/40 text-[#FFCC00] text-xs font-black tracking-wider rotate-[-8deg]">
                  TODO MÊS
                </div>
                <div className="absolute -bottom-3 right-2 px-4 py-2 rounded-full bg-[#FF3B30] text-white text-xs font-black tracking-wider rotate-[6deg] shadow-lg">
                  CONCORRA JÁ
                </div>
                <div className="absolute top-1/2 -right-4 -translate-y-1/2 px-3 py-1.5 rounded-full bg-white text-black text-[10px] font-black tracking-widest rotate-[12deg]">
                  +PRÊMIOS
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
